export default __webpack_public_path__ + "static/media/ic-check.961360ce.svg";